<template>
  <b-container class="wrap-contact">
    <div class="box-head">
      <!-- <h1>ADMIN CONTACT</h1> -->
    </div>

    <div>
      <b-row>
        <b-col cols="12" md="6">
          <b-col v-for="(contact, i) in left" :key="i" cols="12" md="12" class="box-content">
            <div class="box"></div>
            <div class="box-text">
              <h2>{{ contact.title }}</h2>

              <template v-if="contact.type === 'qrcode'">
                <p v-if="contact.dec">{{ contact.dec }}</p>
                <a :href="contact.dec1" target="_blank">
                  {{ contact.dec1 }}
                </a>
              </template>

              <template v-else>
                <p>{{ contact.dec }}</p>
              </template>



              <template v-if="contact.type === 'embed'">
                <iframe class="responsive-iframe" :src="contact.src" width="100%" height="300" style="border:0;"
                  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </template>


              <div class="box-text">
                <template v-if="contact.type === 'qrcode'">
                  <img class="qrcode" src="../../assets/images/OA_QR.png" alt="QR Code">
                </template>
              </div>

              <template v-if="contact.left && contact.left.length">
                <b-row>
                  <div v-for="(subContact, j) in contact.left" :key="j">
                    <div class="box"></div>
                    <div class="box-text">
                      <h3>{{ subContact.title || subContact.title }}</h3>
                      <p v-if="subContact.dec1">{{ subContact.dec1 }}</p>
                    </div>
                  </div>
                </b-row>
              </template>

              <template v-else>

                <p v-if="contact.mail">{{ contact.mail }}</p>
              </template>
            </div>
          </b-col>
        </b-col>
        <b-col cols="12" md="6">
          <b-row>
            <b-col v-for="(content, i) in right" :key="i" cols="12" md="12" class="box-content">
              <div class="box"></div>
              <div class="box-text">
                <h2>{{ content.title }}</h2>
                <template v-if="content.right && content.right.length">
                  <b-row cols="12" md="6">
                    <b-col cols="12" md="6">
                      <div v-for="(subContact, j) in content.left" :key="j" cols="12" md="6" class="sub-content">
                        <div v-if="subContact.title" class="box"></div>

                        <div class="box-title">
                          <div class="box" :class="{ 'invisible': !subContact.title }">
                          </div>
                          <h3 v-if="subContact.title" class="box-text">{{ subContact.title }}</h3>
                        </div>

                        <div class="box-text" v-for="contact in subContact.contacts">
                          <p v-if="contact.dec">{{ contact.dec }}</p>
                          <p v-if="contact.mobile">{{ contact.mobile }}</p>
                          <p v-if="contact.tel">{{ contact.tel }}</p>
                          <p v-if="contact.mail" class="mail-line">{{ contact.mail }}</p>
                        </div>
                      </div>
                    </b-col>

                    <b-col cols="12" md="6">
                      <div v-for="(subContact, j) in content.right" :key="j" cols="12" md="6" class="sub-content">
                        <div v-if="subContact.title" class="box"></div>

                        <div class="box-title">
                          <div class="box" :class="{ 'invisible': !subContact.title }">
                          </div>
                          <h3 v-if="subContact.title" class="box-text">{{ subContact.title }}</h3>
                        </div>

                        <div class="box-text" v-for="contact in subContact.contacts">
                          <p v-if="contact.dec">{{ contact.dec }}</p>
                          <p v-if="contact.mobile">{{ contact.mobile }}</p>
                          <p v-if="contact.tel">{{ contact.tel }}</p>
                          <p v-if="contact.mail" class="mail-line">{{ contact.mail }}</p>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </template>

                <template v-else>
                  <h3 v-if="content.title">{{ content.title }}</h3>
                  <p v-if="content.mail">{{ content.mail }}</p>
                  <p v-if="content.dec1">{{ content.dec1 }}</p>
                  <p v-if="content.mail1">{{ content.mail1 }}</p>
                </template>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>


    <!-- <img src="@/assets/images/map_contact.png"> -->
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      left: [
        {
          title: 'บริษัท แพลนโนวา จำกัด C/O ADMAN AWARDS & SYMPOSIUM',
          dec: 'ที่อยู่ : 1537 ทาวน์ อิน ทาวน์ ซอย 3/1 ถนนศรีวรา แขวงพลับพลา เขตวังทองหลาง กรุงเทพฯ 10310 โทร 02-530-9300',
        },
        {
          title: 'Plannova Map',
          type: 'embed',
          src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.1839702318143!2d100.6076241!3d13.767776699999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29e0f06b38e1d%3A0xc99d211020e80b52!2z4Lia4Lij4Li04Lip4Lix4LiXIOC5geC4nuC4peC4meC5guC4meC4p-C4siDguIjguLPguIHguLHguJQ!5e0!3m2!1sen!2sth!4v1721378795677!5m2!1sen!2sth'
        },
        {
          title: 'LINE Official Account',
          type: 'qrcode',
          dec: 'Add LINE ID: @adman',
          dec1: 'https: //bit.ly/AdmanAward'
        }
      ],
      right: [
        {
          title: 'ติดต่อสอบถาม',
          left: [
            {
              title: "Project",
              contacts: [
                {
                  dec: "ณัฐพร ลือวราพงษ์ (ยุ้ย)",
                  mobile: "Mobile: 087-711-6903",
                  tel: "Tel: 02-530-9300 ext. 23",
                  mail: "Email: natthaporn@plannova.co.th",
                }
              ],
            },
            {
              title: "Awards",
              contacts: [
                {
                  dec: "สิทธวีร์ พัฒน์สินวรกุล (กิ๊ก)",
                  mobile: "Mobile: 061-826-0317",
                  tel: "Tel: 02-530-9300 ext. 26",
                  mail: "Email: sitthawee@plannova.co.th",
                },
                {
                  dec: "เกศวดี แก่งศิริ (บอม)",
                  mobile: "Mobile: 081-422-1703",
                  tel: "Tel: 02-530-9300 ext. 23",
                  mail: "Email: katwadee@plannova.co.th",
                },
                {
                  dec: "กิติศักดิ์ ปิยะวงค์ (เบนซ์)",
                  mobile: "Mobile: 087-711-6904",
                  tel: "Tel: 02-530-9300 ext. 15",
                  mail: "Email: kitisak@plannova.co.th",
                }
              ],
            },
            {
              title: "Symposium",
              contacts: [
                {
                  dec: "ขนิษฐา สำราญ (น้อย)",
                  mobile: "Mobile: 087-711-6905",
                  tel: "Tel: 02-530-9300 ext. 22",
                  mail: "Email: kanitha@plannova.co.th",
                }
              ],
            },
          ],
          right: [
            {
              title: "Sponsors",
              contacts: [{
                dec: "ศุภัทษร เมฆฉาย (แพรว)",
                mobile: "Mobile: 091-759-0164",
                mail: "Email: supatsorn.m@adassothai.com"
              }, {
                dec: "วรรณษา นาคสนิท (นา)",
                mobile: "Mobile: 082-914-2655",
                tel: "Tel: 02-530-9300 ext. 23",
                mail: "Email: khunna@adassothai.com"
              },
              ],
            },
            {
              title: "Finance",
              contacts: [{
                dec: "สุชาดา บุญมาชู (หนู) Awards",
                mobile: "Mobile: 087-717-4976",
                tel: "Tel: 02-530-9300 ext. 20",
                mail: "Email: suchada@plannova.co.th",
              }, {
                dec: "กิตติญา กระจ่างพืช (อ้อย) Symposium",
                mobile: "Mobile: 061-569-6561",
                tel: "Tel: 02-530-9300 ext. 18",
                mail: "Email: kittiya@plannova.co.th",
              }],
            },
          ],
        }
      ]
    }
  },
  methods: {
    generateQrCode(data) {
      return `https://qrcode.tec-it.com/API/QRCode?data=${encodeURIComponent(data)}&size=200`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-contact {
  height: 100%;

  .box-head {
    padding: 22px 0;

    h1 {
      font-size: 1.5rem;
    }
  }

  .row {
    .box-content {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 22px;

      .box {
        margin-top: 5px;
        width: 15px;
        height: 15px;
        background-color: $active;
        position: absolute;
      }

      .mail-line {
        margin-bottom: 0.875rem !important;
      }

      .wrap-contact .row .box-content .box-text .spaced-block {
        margin-top: 16px !important;
      }

      .box-text {
        margin-left: 22px;
        width: 100%;

        h2,
        h3 {
          font-size: 1.5rem
        }

        p {
          margin-top: 4px;
          line-height: 1;
          font-size: 1.25rem
        }

      }
    }
  }

  @media (min-width:576px) {
    .sub-content {
      width: 100%;
      margin-top: 14px;
    }

    .sub-content {
      width: 100%;
      margin-top: 14px;
    }
  }

  img {
    width: 100%;
    margin-bottom: 22px;
  }
}

.qrcode {
  margin-top: 10px;
  width: 200px !important;
}

h3 {
  min-height: 24px; // หรือกำหนดให้เท่ากับ h3 ปกติ
}

p {
  font-size: 0.875rem !important;
  line-height: 1.2 !important;
  font-family: var(--body-upscale-font-family, Sarabun);
}
</style>
